// extracted by mini-css-extract-plugin
module.exports = {"cardIcon":"styles-module__cardIcon___1xmVV","inactive":"styles-module__inactive___3P5AX"};